<div class="p-5">
    <div class="popup-s text-center relative">
        <div class="icon icon-default icon-3 mb-4" inlineSVG="assets/icons.svg#alert-warning"></div>
        <div class="text-m font-semi-bold text-line-2 mb-4 px-6" translate>v3-byoc-empty-course-popup-info</div>
        <div class="text-m font-semi-bold text-line-2 mb-4 px-6" translate>v3-byoc-empty-course-popup-info-2</div>
        <div class="text-m font-semi-bold text-line-2 mb-4 px-6" translate>v3-byoc-empty-course-popup-info-3</div>

        <div class="theme-new d-flex py-2 justify-content-center">
            <div [style.padding-right.rem]="1" class="text-right">
                <button (click)="saveClick()" class="btn btn-primary" translate buttonDataTest="noButton">v3-button-no</button>
            </div>
            <div class="text-left">
                <button (click)="saveAndAddClick()" class="btn btn-secondary" translate buttonDataTest="yesButton">v3-button-yes</button>
            </div>
        </div>

        <app-loader *ngIf="saving" loaderType="relative" loaderColor="default" overlayColor="white"></app-loader>
    </div>
</div>
